module.exports = __webpack_public_path__ + "vrplayerstatic/media/gyroOn.2ba97ff5.svg";